const Facebook = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.0848 21.7208C18.7988 20.7562 22.3448 16.5853 22.3448 11.5862C22.3448 5.87287 17.7133 1.24133 12 1.24133C6.28669 1.24133 1.65515 5.87287 1.65515 11.5862C1.65515 16.5346 5.12965 20.6716 9.77215 21.6905V14.2154H7.44826V11.1394H9.77215V8.51213C9.77215 6.4476 11.1449 4.55168 14.308 4.55168C15.5886 4.55168 16.5357 4.67102 16.5357 4.67102L16.461 7.54345C16.461 7.54345 15.4952 7.53431 14.4413 7.53431C13.3007 7.53431 13.1179 8.04529 13.1179 8.89339V11.1394H16.5517L16.4023 14.2154H13.1179V21.8713C13.445 21.8361 13.7676 21.7857 14.0848 21.7208Z"/>
    </svg>
  )
}

export default Facebook